'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipns = require('ipns');

var base58 = require('multiformats/bases/base58');

var datastorePubsub = require('datastore-pubsub');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

var errCode = require('err-code');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var ipns__namespace = /*#__PURE__*/_interopNamespace(ipns);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = Object.assign(debug__default["default"]('ipfs:ipns:pubsub'), {
  error: debug__default["default"]('ipfs:ipns:pubsub:error')
});

var IpnsPubsubDatastore = /*#__PURE__*/function () {
  function IpnsPubsubDatastore(pubsub, localDatastore, peerId) {
    _classCallCheck(this, IpnsPubsubDatastore);

    this._subscriptions = {};
    this._handleSubscriptionKey = this._handleSubscriptionKey.bind(this);
    this._pubsubDs = new datastorePubsub.PubsubDatastore(pubsub, localDatastore, peerId, ipns__namespace.validator, this._handleSubscriptionKey);
  }

  _createClass(IpnsPubsubDatastore, [{
    key: "put",
    value: function put(key, value) {
      return this._pubsubDs.put(key, value);
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var res, err, ns, stringifiedTopic, id;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this._pubsubDs.get(key);

              case 3:
                res = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                err = _context.t0;

              case 9:
                ns = key.slice(0, ipns__namespace.namespaceLength);

                if (toString.toString(ns) === ipns__namespace.namespace) {
                  stringifiedTopic = base58.base58btc.encode(key).substring(1);
                  id = base58.base58btc.encode(key.slice(ipns__namespace.namespaceLength)).substring(1);
                  this._subscriptions[stringifiedTopic] = id;
                  log("subscribed to pubsub topic ".concat(stringifiedTopic, ", id ").concat(id));
                }

                if (!err) {
                  _context.next = 13;
                  break;
                }

                throw err;

              case 13:
                return _context.abrupt("return", res);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "_handleSubscriptionKey",
    value: function _handleSubscriptionKey(key) {
      if (key instanceof Uint8Array) {
        key = toString.toString(key, 'base58btc');
      }

      var subscriber = this._subscriptions[key];

      if (!subscriber) {
        throw errCode__default["default"](new Error("key ".concat(key, " does not correspond to a subscription")), 'ERR_INVALID_KEY');
      }

      var keys;

      try {
        keys = ipns__namespace.getIdKeys(fromString.fromString(subscriber, 'base58btc'));
      } catch (err) {
        log.error(err);
        throw err;
      }

      return keys.routingKey.uint8Array();
    }
  }, {
    key: "getSubscriptions",
    value: function getSubscriptions() {
      var subscriptions = Object.values(this._subscriptions).filter(Boolean);
      return subscriptions.map(function (sub) {
        return "".concat(ipns__namespace.namespace).concat(sub);
      });
    }
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
        var _this = this;

        var stringifiedTopic, bufTopic;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof name !== 'string')) {
                  _context2.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('invalid subscription name'), 'ERR_INVALID_SUBSCRIPTION_NAME');

              case 2:
                if (name.startsWith(ipns__namespace.namespace)) {
                  name = name.substring(ipns__namespace.namespaceLength);
                }

                stringifiedTopic = Object.keys(this._subscriptions).find(function (key) {
                  return _this._subscriptions[key] === name;
                });

                if (stringifiedTopic) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", {
                  canceled: false
                });

              case 6:
                bufTopic = fromString.fromString(stringifiedTopic);

                this._pubsubDs.unsubscribe(bufTopic);

                delete this._subscriptions[stringifiedTopic];
                log("unsubscribed pubsub ".concat(stringifiedTopic, ": ").concat(name));
                return _context2.abrupt("return", {
                  canceled: true
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function cancel(_x2) {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }]);

  return IpnsPubsubDatastore;
}();

exports.IpnsPubsubDatastore = IpnsPubsubDatastore;